import { mergeStyles } from '@fluentui/react';
import * as React from 'react';
import {
  IUITabViewInfo,
  UITabView,
  UITabViewInfo,
} from '../../../../models/reduxState';
import { RequestPropertyContainer } from '../../containerComponents/RequestDetails/RequestPropertyContainer';
import { RequestFeedbackContainer } from '../../containerComponents/RequestFeedbackContainer/RequestFeedbackContainer';
import {
  FreelanceRequest,
  RequestPropertyKey,
} from '../../models/requestModels';
import {
  getUserDescription,
} from '../../reduxUpdater/selectors/requestSelector';
import {
  getCommonClassNames,
  getCommonStyles,
} from '../../styles/commonStyles';
import {
  IRequestCardStyles,
  getRequestCardClassNames,
} from '../../styles/requestCardStyles';
import { IStyledComponent } from '../../styles/themesUI';
import { RequestHeader } from './RequestHeader';

interface IRequestCardComponentProps {
  request: FreelanceRequest;
  showFeedback: boolean;
  // dispatchers
  updateUITabViewInfo: (uiTabViewInfo: IUITabViewInfo) => void;
  dispatchGetRequest: (requestId: string) => void;
}

type IRequestCardProps = IRequestCardComponentProps & IStyledComponent<IRequestCardStyles>;

export class RequestCard extends React.PureComponent<IRequestCardProps> {
  private commonClassNames = getCommonClassNames(getCommonStyles());
  private requestCardClassNames = getRequestCardClassNames(this.props.styles, { theme: this.props.theme });

  public render(): React.ReactNode {
    const requestCardContainerClassName: string = mergeStyles([
      this.requestCardClassNames.sectionContainer,
      this.requestCardClassNames.cursorPointer,
    ]);

    return (
      <>
        <div
          className={requestCardContainerClassName}
          onClick={this.onRequestCardClick}
          tabIndex={0}
          onKeyDown={this.onRequestCardKeyPress}
          role="button"
        >
          <RequestHeader
            request={this.props.request}
            theme={this.props.theme}
          />
          <div className={mergeStyles(this.requestCardClassNames.contentContainerBase, this.requestCardClassNames.contentContainerPrimary)}>
            <div className={this.requestCardClassNames.contentPrimary}>
              <span>
                <RequestPropertyContainer
                  requestPropertyKey={RequestPropertyKey.State}
                  request={this.props.request}
                />
              </span>
              <span className={this.requestCardClassNames.stateBullet}>
                &bull;
              </span>
            </div>
            <RequestPropertyContainer
              requestPropertyKey={RequestPropertyKey.CreateDateTime}
              request={this.props.request}
            />
          </div>
          <div className={mergeStyles(this.requestCardClassNames.contentContainerBase, this.requestCardClassNames.contentContainerSecondary)}>
            <div
              className={mergeStyles([
                this.commonClassNames.overflowWrapBreakWord,
                this.commonClassNames.overflowHidden,
                this.requestCardClassNames.descriptionSpanContainer,
                this.requestCardClassNames.contentPrimary,
              ])}
            >
              <span>{getUserDescription(this.props.request)}</span>
            </div>
          </div>
        </div>
        {this.props.showFeedback && <RequestFeedbackContainer requestId={this.props.request.RequestId} />}
      </>
    );
  }

  private onRequestCardClick = (): void => {
    if (this.props.request) {
      this.props.dispatchGetRequest(this.props.request.RequestId);
      const uiTabViewInfo = new UITabViewInfo();
      uiTabViewInfo.requestId = this.props.request.RequestId;
      uiTabViewInfo.uITabView = UITabView.requestDetails;
      this.props.updateUITabViewInfo(uiTabViewInfo);
    }
  };

  private onRequestCardKeyPress = (
    event: React.KeyboardEvent<HTMLDivElement>
  ): void => {
    if (event.type === 'keydown' && event.key === 'Enter') {
      this.onRequestCardClick();
    }
  };
}
